module.exports = __webpack_public_path__ + "img/2.8b0dbba5.png";